import {useCallback} from 'react'

import {
  type AllNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {SignUpWizard} from '#/screens/SignUpWizard/SignUpWizard'

type Props = NativeStackScreenProps<AllNavigatorParams, 'Onboarding'>

export function OnboardingScreen({route}: Props) {
  const onComplete = useCallback(() => {
    window.location.replace('/')
  }, [])

  return <SignUpWizard onComplete={onComplete} prefill={route.params} />
}
